import { DefaultSettings, settings, overrideSettings} from '@alme/ui-web/settings/settings-util';
import almeSettings from './alme-api';
import classNames from './class-names';
import {languageConstants} from './language-constants';
import {languageSpecificSettingOverrides} from './language-specific-setting-override';
import messageSettings from './message-constants';
import stateLocations from './state-locations';
import textSettings from './text-constants';
import accessibility from './accessibility';
import windowSettings from './window';
import alightSettings from './generate-new-session-settings';
import livechatSettings from './live-chat';
import analyticsSettings from './analytics';
import appEventSettings from './app-events';
import responseActionSettings from './response-actions';
import navSettings from './nav-constants';
import skinningSettings from './skinning';
import stateCopySettings from './state-copy';
import stateTriggers from './state-triggers';
import error from './error';
import originConstants from './originConstants';
import alightCustomSettings from './settings';

const settingsToOverride = {
    ...alightCustomSettings,
    ...almeSettings,
    ...classNames,
    ...{languageConstants},
    ...{languageSpecificSettingOverrides},
    ...messageSettings,
    ...stateLocations,
    ...stateTriggers,
    ...textSettings,
    ...accessibility,
    ...windowSettings,
    ...alightSettings,
    ...skinningSettings,
    ...stateCopySettings,
    ...livechatSettings,
    ...analyticsSettings,
    ...appEventSettings,
    ...responseActionSettings,
    ...navSettings,
    ...error,
    ...originConstants,
};

function initializeCustomSettings(): void {
    overrideSettings(settingsToOverride);
}

const AlightCustomSettings = settings as AlightCustomSettingsType;
type AlightCustomSettingsType = (typeof settingsToOverride) & DefaultSettings;

export { initializeCustomSettings, AlightCustomSettings, AlightCustomSettingsType};


// WEBPACK FOOTER //
// ./settings/alight-custom-settings.ts